module.exports = __webpack_public_path__ + "media/src/img/logo-ru-c0d98e37638e0eb2483e4d7997db9192.png";